var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.15967H8C4.68629 2.15967 2 4.84596 2 8.15967V24.1597C2 27.4734 4.68629 30.1597 8 30.1597H24C27.3137 30.1597 30 27.4734 30 24.1597V8.15967C30 4.84596 27.3137 2.15967 24 2.15967Z",
    fill: "url(#paint0_radial_51_1408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.15967H8C4.68629 2.15967 2 4.84596 2 8.15967V24.1597C2 27.4734 4.68629 30.1597 8 30.1597H24C27.3137 30.1597 30 27.4734 30 24.1597V8.15967C30 4.84596 27.3137 2.15967 24 2.15967Z",
    fill: "url(#paint1_radial_51_1408)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.15967H8C4.68629 2.15967 2 4.84596 2 8.15967V24.1597C2 27.4734 4.68629 30.1597 8 30.1597H24C27.3137 30.1597 30 27.4734 30 24.1597V8.15967C30 4.84596 27.3137 2.15967 24 2.15967Z",
    fill: "url(#paint2_radial_51_1408)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.6597C23 11.4881 22.3284 12.1597 21.5 12.1597C20.6716 12.1597 20 11.4881 20 10.6597C20 9.83124 20.6716 9.15967 21.5 9.15967C22.3284 9.15967 23 9.83124 23 10.6597Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.1597C18.7614 21.1597 21 18.9211 21 16.1597C21 13.3983 18.7614 11.1597 16 11.1597C13.2386 11.1597 11 13.3983 11 16.1597C11 18.9211 13.2386 21.1597 16 21.1597ZM16 19.1597C17.6569 19.1597 19 17.8166 19 16.1597C19 14.5028 17.6569 13.1597 16 13.1597C14.3431 13.1597 13 14.5028 13 16.1597C13 17.8166 14.3431 19.1597 16 19.1597Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15.7597C6 12.3994 6 10.7192 6.65396 9.43573C7.2292 8.30675 8.14708 7.38887 9.27606 6.81363C10.5595 6.15967 12.2397 6.15967 15.6 6.15967H16.4C19.7603 6.15967 21.4405 6.15967 22.7239 6.81363C23.8529 7.38887 24.7708 8.30675 25.346 9.43573C26 10.7192 26 12.3994 26 15.7597V16.5597C26 19.92 26 21.6002 25.346 22.8836C24.7708 24.0126 23.8529 24.9305 22.7239 25.5057C21.4405 26.1597 19.7603 26.1597 16.4 26.1597H15.6C12.2397 26.1597 10.5595 26.1597 9.27606 25.5057C8.14708 24.9305 7.2292 24.0126 6.65396 22.8836C6 21.6002 6 19.92 6 16.5597V15.7597ZM15.6 8.15967H16.4C18.1132 8.15967 19.2777 8.16123 20.1779 8.23477C21.0548 8.30641 21.5032 8.43626 21.816 8.59564C22.5686 8.97914 23.1805 9.59106 23.564 10.3437C23.7234 10.6565 23.8533 11.1049 23.9249 11.9818C23.9984 12.882 24 14.0465 24 15.7597V16.5597C24 18.2729 23.9984 19.4374 23.9249 20.3376C23.8533 21.2145 23.7234 21.6629 23.564 21.9757C23.1805 22.7283 22.5686 23.3402 21.816 23.7237C21.5032 23.8831 21.0548 24.013 20.1779 24.0846C19.2777 24.1581 18.1132 24.1597 16.4 24.1597H15.6C13.8868 24.1597 12.7223 24.1581 11.8221 24.0846C10.9452 24.013 10.4968 23.8831 10.184 23.7237C9.43139 23.3402 8.81947 22.7283 8.43597 21.9757C8.27659 21.6629 8.14674 21.2145 8.0751 20.3376C8.00156 19.4374 8 18.2729 8 16.5597V15.7597C8 14.0465 8.00156 12.882 8.0751 11.9818C8.14674 11.1049 8.27659 10.6565 8.43597 10.3437C8.81947 9.59106 9.43139 8.97914 10.184 8.59564C10.4968 8.43626 10.9452 8.30641 11.8221 8.23477C12.7223 8.16123 13.8868 8.15967 15.6 8.15967Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_51_1408",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 23.1597) rotate(-55.3758) scale(25.5196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_51_1408",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11 31.1597) rotate(-65.1363) scale(22.5942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_51_1408",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.5 3.15967) rotate(-8.1301) scale(38.8909 8.31836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e54338c8a577c3a336e5a6f9cd3fd987.svg";
export { ForwardRef as ReactComponent };